import { Card, Row, Col, Statistic, Typography } from "antd";
import { ResponsiveContainer, AreaChart, Area, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { DollarOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { IntelligenceDto } from "dtos/application.dto";
import { twColors } from "utils/constants";
import { formatMoney } from "utils/functions";
import { AppCard } from "components/AppCard";

type OverViewProps = {
  data: IntelligenceDto;
};

const NetAnalytics = ({ data }: OverViewProps) => {
  return (
    <div className="flex flex-col gap-6">
      {/* Summary Cards */}
      <Row gutter={16}>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Net Profit"
              value={data.net_margin_summary.net_profit}
              valueStyle={{ color: data.net_margin_summary.net_profit > 0 ? twColors.green600 : twColors.red600 }}
              formatter={(value) => `${formatMoney(Number(value), false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Net Margin %"
              value={data.net_margin_summary.net_margin_percent}
              suffix="%"
              valueStyle={{
                color: data.net_margin_summary.net_margin_percent > 0 ? twColors.green600 : twColors.red600,
              }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Total Revenue"
              value={data.net_margin_summary.total_revenue}
              valueStyle={{ color: data.net_margin_summary.total_revenue > 0 ? twColors.green600 : twColors.red600 }}
              formatter={(value) => `${formatMoney(Number(value), false)}`}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="border-1 border-gray-300 ">
            <Statistic
              title="Profit Std Dev"
              value={data.net_yearly_profit_std}
              valueStyle={{
                color: Number(data?.net_yearly_profit_std ?? 0) > 0 ? twColors.green600 : twColors.red600,
              }}
              formatter={(value) => `${formatMoney(Number(value), false, false)}`}
            />
          </Card>
        </Col>
      </Row>

      {/* {data.net_yearly_profit: (
                  <div className="w-full flex-1">
                    <AppCard className="p-6 flex flex-col mx-auto h-full">
                      {graphs.isLoading ? (
                        loader
                      ) : graphs.data?.result?.original_vs_optimal_payment ? (
                        <>
                          <Typography.Title level={5} className="!m-0">
                            Current Payment v/s Optimal Payment
                          </Typography.Title>
                          <Divider />
                          <div style={{ width: "100%", height: 300 }}>
                            <ReOriginalOptimalBarChart
                              data={graphs.data?.result?.original_vs_optimal_payment}
                              // indexBy="id"
                              // keys={["original_amount", "optimal_amount"]}
                              // legend={{ x: "", y: "Amount" }}
                              // groupMode="grouped"
                            />
                          </div>
                        </>
                      ) : graphs?.data?.result?.external?.charts?.fundedAmountByCreditor ? (
                        <>
                          <Typography.Title level={5} className="!m-0">
                            Funded Amount By Creditor
                          </Typography.Title>
                          <Divider />
                          <div style={{ width: "100%", height: 300 }}>
                            <BarChart
                              data={graphs.data?.result?.external?.charts?.fundedAmountByCreditor}
                              indexBy="creditor"
                              keys={["fundedAmount"]}
                              legend={{ x: "Creditor", y: "Funded Amount" }}
                              groupMode="grouped"
                            />
                          </div>
                        </>
                      ) : null}
                    </AppCard>
                  </div>
                )} */}

      <Card className="border-1 border-gray-300 " title="Yearly Profit Trend">
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data.net_yearly_profit}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="year" tick={{ fill: "#666", fontSize: 12 }} />
              <YAxis tick={{ fill: "#666", fontSize: 12 }} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                }}
                formatter={(value, name) => [
                  `$${Number(value).toLocaleString()}`,
                  name === "net_value" ? "Net Profit" : "Revenue",
                ]}
              />
              <Area
                type="monotone"
                dataKey="net_value"
                stroke={twColors.green600}
                fill={twColors.green500}
                fillOpacity={0.3}
              />
              <Area
                type="monotone"
                dataKey="revenue"
                stroke={twColors.blue600}
                fill={twColors.blue500}
                fillOpacity={0.2}
              />
              <Legend
                verticalAlign="top"
                height={36}
                wrapperStyle={{ fontSize: 12, color: "#666" }}
                formatter={(value) => (value === "net_value" ? "Net Profit" : "Revenue")}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

export default NetAnalytics;
